<template>
  <div>
    <div class="container-fluid nav-head">
      <b-navbar toggleable="lg" type="dark" class="navbar container">
        <b-navbar-brand style="margin-left: 2%" href="#"
          ><img
            src="./assets/bee-taxi.png"
            id="beelogo"
            alt="BeeTaxi Logo"
            width="8%"
        /></b-navbar-brand>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <!--          <b-nav-item href="#hello">Link</b-nav-item>-->
            <!--          <b-nav-item href="#">Disabled</b-nav-item>-->
            <div class="menu" id="menu">
              <ul class="menu-inner">
                <li class="menu-item">
                  <a href="#hero" class="menu-link">Home</a>
                </li>
                <li class="menu-item">
                  <a href="#brief" class="menu-link">Feature</a>
                </li>
                <li class="menu-item">
                  <a href="#service" class="menu-link">Service</a>
                </li>
                <li class="menu-item">
                  <a href="#about" class="menu-link">Product</a>
                </li>
              </ul>
            </div>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div id="app">
      <div class="row hero" style="display: flex">
        <HeroSection id="hero" />
      </div>
      <br />
      <br />
      <div class="row" style="display: flex">
        <MarketingBrief id="brief" />
      </div>
      <div
        style="display: flex"
        class="row mt-5 moto-widget moto-widget-block moto-background-fixed moto-spacing-top-large moto-spacing-right-auto moto-spacing-bottom-medium moto-spacing-left-auto"
      >
        <ServiceSection id="service" />
      </div>

      <div class="row" style="min-height: 90vh">
        <AboutService />
      </div>
      <div class="row">
        <AboutUs id="about" msg="Welcome to Your Vue.js App" />
      </div>
      <div class="row my-5" style="display: flex; min-height: 60vh">
        <ContactUs id="contact" />
      </div>
      <footer class="footer">
        <hr />
        <div class="row CopyWrite">
          <strong
            >Copyright © <span> {{ new Date().getFullYear() }} </span>BeeTaxi.
            all rights reserved.</strong
          >
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import AboutUs from "./components/AboutUs.vue";
import HeroSection from "./components/HeroSection.vue";
import MarketingBrief from "./components/MarketingBrief.vue";
// import OurService from "./components/OurService.vue";
import ServiceSection from "./components/ServiceSection.vue";
import AboutService from "./components/AboutService.vue";
import ContactUs from "./components/ContactUs.vue";
export default {
  name: "App",
  components: {
    AboutUs,
    HeroSection,
    MarketingBrief,
    // OurService,
    ContactUs,
    ServiceSection,
    AboutService,
  },
};
</script>

<style scoped lang="scss">
@import url("http://fonts.googleapis.com/css?family=Raleway:400,100,200,300,500,600,800,700,900");
:root {
  --color-white-100: hsl(206, 5%, 98%);
  --color-white-200: hsl(206, 5%, 90%);
  --color-white-300: hsl(206, 5%, 80%);
  --color-white-400: hsl(206, 5%, 65%);
  --color-white-500: hsl(206, 5%, 50%);
  --color-white-600: hsl(206, 5%, 35%);

  --color-black-100: hsl(213, 20%, 9%);
  --color-black-200: hsl(213, 23%, 8%);
  --color-black-300: hsl(214, 21%, 6%);
  --color-black-400: hsl(210, 21%, 6%);
  --color-black-500: hsl(216, 22%, 4%);
  --color-black-600: hsl(220, 18%, 3%);
  --color-black-700: hsl(220, 27%, 2%);
  --color-black-800: hsl(180, 20%, 1%);

  --color-blue-100: hsl(214, 95%, 93%);
  --color-blue-200: hsl(213, 97%, 87%);
  --color-blue-300: hsl(212, 96%, 78%);
  --color-blue-400: hsl(213, 94%, 68%);
  --color-blue-500: hsl(217, 91%, 60%);
  --color-blue-600: hsl(221, 83%, 53%);
  --color-blue-700: hsl(224, 76%, 48%);
  --color-blue-800: hsl(226, 71%, 40%);
  --color-blue-900: hsl(224, 64%, 33%);

  --shadow-small: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-medium: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-large: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
  list-style-type: none;
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

html {
  font-size: 100%;
  box-sizing: inherit;
  scroll-behavior: smooth;
  height: -webkit-fill-available;
}

body {
  font-family: "Raleway", sans-serif;
  font-size: clamp(1rem, 2vw, 1.125rem);
  font-weight: 400;
  line-height: 1.5;
  height: -webkit-fill-available;
  color: var(--color-white-100);
  background-color: var(--color-black-500);
}
#app {
  font-family: "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 69px;
  overflow: hidden;
  background-color: #2c3e50;
}
.nav-head {
  background-color: #eff5f5;
  opacity: 0.8;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: auto;
  margin: 0 auto;
  color: #000000;
  transition: all 0.35s ease;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 93%);

  &.on-scroll {
    background: var(--color-black-300);
    box-shadow: var(--shadow-medium);
  }
}
.container {
  max-width: 75rem;
  height: auto;
  margin: 0 auto;
  padding: 0 1.25rem;
}
.navbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 1rem;
  width: 100%;
  height: 4.25rem;
  margin: 0 auto;
}
//#nav-collapse{
//  font-weight: 700;
//  mix-blend-mode: difference;
//}
.hero {
  border: solid;
  border-top: none;
  border-bottom-color: #7f9e9b;
}
.menu {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: auto;
  padding: 4rem 0 3rem;
  overflow: hidden;
  background-color: var(--color-black-300);
  box-shadow: var(--shadow-medium);
  transition: all 0.4s ease-in-out;
  //color:#ffffff;

  &.is-active {
    top: 0;
    width: 100%;
    height: auto;
  }

  &-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 1.25rem;
  }

  &-link {
    font-family: inherit;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--color-white-100);
    text-transform: uppercase;
    transition: all 0.3s ease;
  }

  &-block {
    display: inline-block;
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25;
    user-select: none;
    white-space: nowrap;
    text-align: center;
    margin-left: auto;
    padding: 0.65rem 1.5rem;
    border-radius: 3rem;
    text-transform: capitalize;
    color: var(--color-white);
    background-color: var(--color-blue-600);
    box-shadow: var(--shadow-medium);
    transition: all 0.3s ease-in-out;
  }

  // Responsive Media Query
  @media only screen and (min-width: 48rem) {
    position: relative;
    top: 0;
    width: auto;
    height: auto;
    padding: 0rem;
    margin-left: auto;
    background: none;
    box-shadow: none;

    &-inner {
      display: flex;
      flex-direction: row;
      column-gap: 2rem;
      margin: 0 auto;
    }

    &-link {
      text-transform: capitalize;
    }

    &-block {
      margin-left: 2rem;
    }
  }
}
.burger {
  position: relative;
  display: block;
  cursor: pointer;
  user-select: none;
  order: -1;
  z-index: 10;
  width: 1.75rem;
  height: 1rem;
  border: none;
  outline: none;
  background: none;
  visibility: visible;
  transform: rotate(0deg);
  transition: 0.35s ease;

  // Responsive Media Query
  @media only screen and (min-width: 48rem) {
    display: none;
    visibility: hidden;
  }

  &-line {
    position: absolute;
    display: block;
    right: 0;
    width: 100%;
    height: 2px;
    border: none;
    outline: none;
    opacity: 1;
    transform: rotate(0deg);
    //background-color: var(--color-white-100);
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2) {
      top: 0.5rem;
    }
    &:nth-child(3) {
      top: 1rem;
    }
  }

  &.is-active .burger-line {
    &:nth-child(1) {
      top: 0.5rem;
      transform: rotate(135deg);
    }
    &:nth-child(2) {
      right: -1.5rem;
      opacity: 0;
      visibility: hidden;
    }
    &:nth-child(3) {
      top: 0.5rem;
      transform: rotate(-135deg);
    }
  }
}

@media screen and (max-width: 600px) {
  #beelogo {
    width: 14%;
  }
}
@media screen and (max-width: 768px) {
  #beelogo {
    width: 10%;
  }
}
@media screen and (max-width: 520px) {
  #beelogo {
    width: 17%;
  }
}

.footer {
  flex-shrink: 0;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  //padding: 40px;
}
.CopyWrite {
  //margin-top:10%;
  padding: 20px;
}
footer {
  background: #2c3e50;
  //opacity: 0.7;
  color: rgb(255, 222, 32);
  //height: 40vh;
}
.moto-widget {
  background-image: url("@/assets/services.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.container-fluid,
.moto-cell,
.moto-cell.moto-spacing-left-auto {
  padding-left: 15px;
}
.container-fluid,
.moto-cell,
.moto-cell.moto-spacing-right-auto {
  padding-right: 15px;
}
.row {
  margin-left: -15px;
  margin-right: -15px;
}
.moto-container_width-fixed,
.row-fixed .container-fluid {
  max-width: 1200px;
}
.moto-spacing-top-auto {
  padding-top: initial;
}
.moto-spacing-top-zero {
  padding-top: 0;
}
.moto-spacing-top-small {
  padding-top: 25px;
}
.moto-spacing-top-medium {
  padding-top: 100px;
}
.moto-spacing-top-large {
  padding-top: 100px;
}
.moto-spacing-bottom-auto {
  padding-bottom: initial;
}
.moto-spacing-bottom-zero {
  padding-bottom: 0;
}
.moto-spacing-bottom-small {
  padding-bottom: 25px;
}
.moto-spacing-bottom-medium {
  padding-bottom: 60px;
}
.moto-spacing-bottom-large {
  padding-bottom: 100px;
}
.moto-spacing-left-auto {
  padding-left: initial;
}
.moto-spacing-left-zero {
  padding-left: 0;
}
.moto-spacing-left-small {
  padding-left: 25px;
}
.moto-spacing-left-medium {
  padding-left: 60px;
}
.moto-spacing-left-large {
  padding-left: 100px;
}
.moto-spacing-right-auto {
  padding-right: initial;
}
.moto-spacing-right-zero {
  padding-right: 0;
}
.moto-spacing-right-small {
  padding-right: 25px;
}
.moto-spacing-right-medium {
  padding-right: 60px;
}
.moto-spacing-right-large {
  padding-right: 100px;
}
@media (max-width: 1039px) {
  .moto-spacing-top-small {
    padding-top: 20px;
  }
  .moto-spacing-top-medium {
    padding-top: 30px;
  }
  .moto-spacing-top-large {
    padding-top: 35px;
  }
  .moto-spacing-bottom-small {
    padding-bottom: 20px;
  }
  .moto-spacing-bottom-medium {
    padding-bottom: 30px;
  }
  .moto-spacing-bottom-large {
    padding-bottom: 35px;
  }
  .moto-spacing-left-small {
    padding-left: 20px;
  }
  .moto-spacing-left-medium {
    padding-left: 30px;
  }
  .moto-spacing-left-large {
    padding-left: 35px;
  }
  .moto-spacing-right-small {
    padding-right: 20px;
  }
  .moto-spacing-right-medium {
    padding-right: 30px;
  }
  .moto-spacing-right-large {
    padding-right: 35px;
  }
}
@media (max-width: 767px) {
  .moto-spacing-top-small {
    padding-top: 20px;
  }
  .moto-spacing-top-medium {
    padding-top: 30px;
  }
  .moto-spacing-top-large {
    padding-top: 50px;
  }
  .moto-spacing-bottom-small {
    padding-bottom: 20px;
  }
  .moto-spacing-bottom-medium {
    padding-bottom: 30px;
  }
  .moto-spacing-bottom-large {
    padding-bottom: 50px;
  }
  .moto-spacing-left-small {
    padding-left: 20px;
  }
  .moto-spacing-left-medium {
    padding-left: 30px;
  }
  .moto-spacing-left-large {
    padding-left: 50px;
  }
  .moto-spacing-right-small {
    padding-right: 20px;
  }
  .moto-spacing-right-medium {
    padding-right: 30px;
  }
  .moto-spacing-right-large {
    padding-right: 50px;
  }
}
@media (max-width: 479px) {
  .moto-spacing-top-small {
    padding-top: 15px;
  }
  .moto-spacing-top-medium {
    padding-top: 30px;
  }
  .moto-spacing-top-large {
    padding-top: 50px;
  }
  .moto-spacing-bottom-small {
    padding-bottom: 15px;
  }
  .moto-spacing-bottom-medium {
    padding-bottom: 30px;
  }
  .moto-spacing-bottom-large {
    padding-bottom: 50px;
  }
  .moto-spacing-left-small {
    padding-left: 15px;
  }
  .moto-spacing-left-medium {
    padding-left: 30px;
  }
  .moto-spacing-left-large {
    padding-left: 50px;
  }
  .moto-spacing-right-small {
    padding-right: 15px;
  }
  .moto-spacing-right-medium {
    padding-right: 30px;
  }
  .moto-spacing-right-large {
    padding-right: 50px;
  }
}
.moto-parallax,
.moto-background-fixed {
  background-attachment: fixed;
}
</style>
